@if (gridLayout) {
  @for (section of sections(); track section.name) {
    @if (section.name) {
      <h3 class="sf-section-title">{{ section.name }}</h3>
    }

    <div class="sf-grid">
      @for (control of section.controls; track control) {
        <div class="sf-cell" [ngClass]="cellClass(control)">
          @if (isObject(control)) {
            <h2 class="h4 m0">
              {{ schema?.properties?.[control]?.title ?? control | titlecase }}
            </h2>
            @if (schema?.properties?.[control]?.description) {
              <small>{{ schema?.properties?.[control]?.description }}</small>
            }
          }
          <sfo-dynamic-field
            [schema]="fieldSchema(control)"
            [aFormControl]="aFormControl"
            [renderMode]="'quickSettings'"
            [control]="control"
          ></sfo-dynamic-field>
        </div>
      }
    </div>

    @if (section.hiddenRoles.length || section.hiddenFields.length) {
      <div class="sf-add-role">
        @if (section.hiddenRoles.length) {
          <button type="button" mat-stroked-button [matMenuTriggerFor]="roleMenu">
            <mat-icon>group_add</mat-icon>
            Add contributor role
          </button>
          <mat-menu #roleMenu="matMenu">
            @for (role of section.hiddenRoles; track role) {
              <button type="button" mat-menu-item (click)="revealRole(role)">
                {{ roleLabel(role) }}
              </button>
            }
          </mat-menu>
        }
        @if (section.hiddenFields.length) {
          <button type="button" mat-stroked-button [matMenuTriggerFor]="fieldMenu">
            <mat-icon>add</mat-icon>
            More fields
          </button>
          <mat-menu #fieldMenu="matMenu">
            @for (field of section.hiddenFields; track field) {
              <button type="button" mat-menu-item (click)="revealField(field)">
                {{ fieldLabel(field) }}
              </button>
            }
          </mat-menu>
        }
      </div>
    }
  }
} @else {
  @for (control of controlsInOrder(); track control) {
    <div>
      @if (schema && schema.properties?.[control]?.type === 'object') {
        <ng-container>
          <h2 class="h4 m0">
            {{ schema.properties?.[control]?.title ?? control | titlecase }}
          </h2>
          @if (schema.properties?.[control]?.description) {
            <small>{{schema.properties?.[control]?.description}}</small>
          }
        </ng-container>
      }
      @if (schema && schema.properties?.[control]) {
        <sfo-dynamic-field
          [schema]="schema.properties?.[control]"
          [aFormControl]="aFormControl"
          [renderMode]="'quickSettings'"
          [control]="control"
        ></sfo-dynamic-field>
      }
    </div>
  }
}
